import styled from 'styled-components';

import { Color, FontWeight } from '../../../../enums';
import { StyledComponent } from '../../../../interfaces';
import { Icon } from '../../../icon/icon.component';
import { Markdown } from '../../../markdown/markdown.component';

export const Container: StyledComponent<'div'> = styled.div``;

export const Title: StyledComponent<'div'> = styled.div`
  padding: 20px 0;
  font-weight: ${FontWeight.Medium};
  font-size: 18px;
  line-height: 26px;
  color: ${Color.Black};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const StyledIcon: StyledComponent<typeof Icon> = styled(Icon)`
  flex-shrink: 0;
  margin-left: 10px;
`;

export const ContentContainer: StyledComponent<'div'> = styled.div`
  border-top: 1px solid ${Color.Gray300};
`;

export const ContentWrapper: StyledComponent<'div'> = styled.div`
  padding: 20px 0;
`;

export const Content: StyledComponent<typeof Markdown> = styled(Markdown)`
  p {
    font-weight: ${FontWeight.Light};
    font-size: 16px;
    line-height: 22px;
  }

  p + p {
    margin-top: 24px;
  }
`;
